export const resursColors = {
    primary: {
        100: '#26938f',
        // 200: '#00807b',
        200: '#117069',
        300: '#006464',
        400: '#005050',
        500: '#003C3C',
        600: '#002D2D',
        DEFAULT: '#117069',
    },
    secondary: {
        100: '#F0F000',
        200: '#FFBE00',
        300: '#D28700',
        400: '#C85F00',
        500: '#AA3200',
        DEFAULT: '#D28700',
    },
    tertiary: {
        100: '#98847C',
        200: '#130E09',
        300: '#C8BCB4',
        400: '#AE8A78',
        500: '#2C2C2B',
        600: '#3C2E29',
        DEFAULT: '#AE8A78',
    },
    //placeholder for now
    accent: {
        100: '#FDB987',
        200: '#FDB987',
        DEFAULT: '#FDB987',
    },
    //placeholder for now
    accentAlt: {
        100: '#FDB987',
        200: '#FDB987',
        DEFAULT: '#FDB987',
    },
    success: {
        400: '#6cc24a',
        DEFAULT: '#6cc24a',
    },
    //placeholder for now
    successAlt: {
        400: '#6cc24a',
        DEFAULT: '#6cc24a',
    },
    warning: {
        400: '#dc2828',
        DEFAULT: '#dc2828',
    },
    danger: {
        400: '#dc2828',
        DEFAULT: '#dc2828',
    },
    //placeholder for now
    disabled: {
        400: '#D0D0D0',
        DEFAULT: '#D0D0D0',
    },
    subdued: {
        100: '#F0F0F0',
        200: '#E0E0E0',
        300: '#D0D0D0',
        400: '#C0C0C0',
        500: '#B0B0B0',
        600: '#A0A0A0',
        700: '#909090',
        800: '#808080',
        900: '#707070',
        DEFAULT: '#B0B0B0',
    },
    focus: {
        DEFAULT: '#FDB987',
        blue: '#005fcc',
    },
    shakti: {
        DEFAULT: '#aed5d5',
    },
};

// @todo figure out how to get these values from tailwind config
const colors = {
    black: '#000000',
    darkGrey: '#2f353d',
    white: '#ffffff',
    almostWhite: '#f8f9fa',
    superLightGrey: '#eeeeee',
    darkWhite: '#e0e0e0',
    lightGrey: '#e0e0e0',
    blue: resursColors.primary['DEFAULT'],
    blueAlt: resursColors.primary[100],
    lightBlue: resursColors.primary[200],
    superLightBlue: 'rgb(0, 215, 180)',
    darkBlue: resursColors.primary['DEFAULT'],
    superDarkBlue: resursColors.primary[600],
    purple: resursColors.secondary['DEFAULT'],
    orange: resursColors.secondary[500],
    peach: resursColors.secondary[400],
    lightPeach: '#fdb987',
    pink: '#ff97ae',
    lightPink: '#f7ced7',
    greenLoan: '#b2d6d3',
    darkest: '#000000',
    grayDarkest: '#121518',
    grayDarker: '#2f353d',
    grayDark: '#4d5057',
    grayAlt: '#646464',
    gray: '#83838f',
    grayLighter: '#9f9f9f',
    grayLightest: '#b1b1b1',
    blueLightest: '#f1f5f9',
    blueLight: '#e6faff',
    lightest: '#ffffff',
    lighter: '#f8f9fa',
    light: '#eeeeee',
    lightAlt: '#e0e0e0',
    transparent: 'transparent',
    primary: resursColors.primary['DEFAULT'],
    primaryAlt: resursColors.primary[100],
    primaryLighter: resursColors.primary[200],
    primaryLightest: 'rgb(0, 215, 180)',
    primaryDarker: resursColors.primary[500],
    primaryDarkest: resursColors.primary[600],
    secondary: resursColors.secondary['DEFAULT'],
    secondaryLighter: resursColors.secondary[200],
    secondaryLightest: resursColors.secondary[100],
    secondaryDarker: resursColors.secondary[400],
    secondaryDarkest: resursColors.secondary[500],
    accent1: resursColors.secondary[500],
    accent2: resursColors.secondary[400],
    accent3: '#fdb987',
    accent4: '#ff97ae',
    accent5: '#f7ced7',
    accent6: '#f8e5eb',
    accent7: '#ec9bba',
    accent8: '#d6ebea',
    accent9: '#f2e9e5',
    accent10: '#bfdfde',
    success: '#6cc24a',
    error: resursColors.danger['DEFAULT'],
    bulletListOrange: '#EB5D2A',
    teal: resursColors.primary[300],
    darkGreen: resursColors.primary[400],
    blueText: '#001489',
    tertiaryOne: resursColors.tertiary[100],
    tertiaryTwo: resursColors.tertiary[200],
    tertiaryThree: resursColors.tertiary[300],
    tertiaryFour: resursColors.tertiary[400],
    tertiaryFive: resursColors.tertiary[500],
    tertiarySix: resursColors.tertiary[600],
    beige: '#f8f9fa',
    darkBeige: '#e5ddd5',
    lightBrown: '#4c3d37',
    listCheck: '#27c0a8',
    warmWhite: '#f7f0eb',
};

export function getTailwindColor(key?: string | unknown, property: 'bg' | 'text' | 'border' | 'fill' | 'stroke' = 'bg') {
    if (typeof key !== 'string') {
        return null;
    }

    let match = null;

    switch (key) {
        case 'black':
        case 'darkest':
            match = {
                bg: 'r-bg-black',
                text: 'r-text-black',
                border: 'r-border-black',
                fill: 'r-fill-black',
                stroke: 'r-stroke-black',
            };
            break;
        case 'darkGrey':
            match = {
                bg: 'r-bg-neutral-700',
                text: 'r-text-neutral-700',
                border: 'r-border-neutral-700',
                fill: 'r-fill-neutral-700',
                stroke: 'r-stroke-neutral-700',
            };
            break;
        case 'white':
        case 'lightest':
        case '#fff':
        case '#ffffff':
            match = {
                bg: 'r-bg-white',
                text: 'r-text-white',
                border: 'r-border-white',
                fill: 'r-fill-white',
                stroke: 'r-stroke-white',
            };
            break;
        case 'almostWhite':
        case 'lighter':
            match = {
                bg: 'r-bg-gray-50',
                text: 'r-text-gray-50',
                border: 'r-border-gray-50',
                fill: 'r-fill-gray-50',
                stroke: 'r-stroke-gray-50',
            };
            break;
        case 'superLightGrey':
        case 'superLightGray':
        case 'lightGray':
        case 'lightGrey':
        case 'light':
        case '#eee':
        case '#eeeeee':
            match = {
                bg: 'r-bg-[#eeeeee]',
                text: 'r-text-[#eeeeee]',
                border: 'r-border-[#eeeeee]',
                fill: 'r-fill-[#eeeeee]',
                stroke: 'r-stroke-[#eeeeee]',
            };
            break;
        case 'darkWhite':
            match = {
                bg: 'r-bg-neutral-200',
                text: 'r-text-neutral-200',
                border: 'r-border-neutral-200',
                fill: 'r-fill-neutral-200',
                stroke: 'r-stroke-neutral-200',
            };
            break;
        case 'blue':
        case 'darkBlue':
        case 'superDarkBlue':
        case 'purple':
        case 'primary':
            match = {
                bg: 'r-bg-primary',
                text: 'r-text-primary',
                border: 'r-border-primary',
                fill: 'r-fill-primary',
                stroke: 'r-stroke-primary',
            };
            break;
        case 'blueAlt':
        case 'primaryAlt':
            match = {
                bg: 'r-bg-primary-100',
                text: 'r-text-primary-100',
                border: 'r-border-primary-100',
                fill: 'r-fill-primary-100',
                stroke: 'r-stroke-primary-100',
            };
            break;
        case 'lightBlue':
        case 'primaryLighter':
            match = {
                bg: 'r-bg-primary-200',
                text: 'r-text-primary-200',
                border: 'r-border-primary-200',
                fill: 'r-fill-primary-200',
                stroke: 'r-stroke-primary-200',
            };
            break;
        case 'tertiaryOne':
            match = {
                bg: 'r-bg-[#98847C]',
                text: 'r-text-[#98847C]',
                border: 'r-border-[#98847C]',
                fill: 'r-fill-[#98847C]',
                stroke: 'r-stroke-[#98847C]',
            };
            break;
        case 'tertiaryTwo':
            match = {
                bg: 'r-bg-[#130E09]',
                text: 'r-text-[#130E09]',
                border: 'r-border-[#130E09]',
                fill: 'r-fill-[#130E09]',
                stroke: 'r-stroke-[#130E09]',
            };
            break;
        case 'tertiaryThree':
            match = {
                bg: 'r-bg-[#C8BCB4]',
                text: 'r-text-[#C8BCB4]',
                border: 'r-border-[#C8BCB4]',
                fill: 'r-fill-[#C8BCB4]',
                stroke: 'r-stroke-[#C8BCB4]',
            };
            break;
        case 'tertiaryFour':
            match = {
                bg: 'r-bg-[#AE8A78]',
                text: 'r-text-[#AE8A78]',
                border: 'r-border-[#AE8A78]',
                fill: 'r-fill-[#AE8A78]',
                stroke: 'r-stroke-[#AE8A78]',
            };
            break;
        case 'tertiaryFive':
            match = {
                bg: 'r-bg-[#2C2C2B]',
                text: 'r-text-[#2C2C2B]',
                border: 'r-border-[#2C2C2B]',
                fill: 'r-fill-[#2C2C2B]',
                stroke: 'r-stroke-[#2C2C2B]',
            };
            break;
        case 'tertiarySix':
            match = {
                bg: 'r-bg-[#3C2E29]',
                text: 'r-text-[#3C2E29]',
                border: 'r-border-[#3C2E29]',
                fill: 'r-fill-[#3C2E29]',
                stroke: 'r-stroke-[#3C2E29]',
            };
            break;
        case 'teal':
        case 'rgb(0, 100, 100)':
            match = {
                bg: 'r-bg-primary-300',
                text: 'r-text-primary-300',
                border: 'r-border-primary-300',
                fill: 'r-fill-primary-300',
                stroke: 'r-stroke-primary-300',
            };
            break;
        case 'peach':
        case 'darkGreen':
            match = {
                bg: 'r-bg-primary-400',
                text: 'r-text-primary-400',
                border: 'r-border-primary-400',
                fill: 'r-fill-primary-400',
                stroke: 'r-stroke-primary-400',
            };
            break;
        case 'orange':
        case 'primaryDarker':
            match = {
                bg: 'r-bg-primary-500',
                text: 'r-text-primary-500',
                border: 'r-border-primary-500',
                fill: 'r-fill-primary-500',
                stroke: 'r-stroke-primary-500',
            };
            break;
        case 'primaryDarkest':
            match = {
                bg: 'r-bg-primary-600',
                text: 'r-text-primary-600',
                border: 'r-border-primary-600',
                fill: 'r-fill-primary-600',
                stroke: 'r-stroke-primary-600',
            };
            break;
        case 'secondary':
            match = {
                bg: 'r-bg-secondary',
                text: 'r-text-secondary',
                border: 'r-border-secondary',
                fill: 'r-fill-secondary',
                stroke: 'r-stroke-secondary',
            };
            break;
        case 'secondaryLighter':
            match = {
                bg: 'r-bg-secondary-200',
                text: 'r-text-secondary-200',
                border: 'r-border-secondary-200',
                fill: 'r-fill-secondary-200',
                stroke: 'r-stroke-secondary-200',
            };
            break;
        case 'secondaryLightest':
            match = {
                bg: 'r-bg-secondary-100',
                text: 'r-text-secondary-100',
                border: 'r-border-secondary-100',
                fill: 'r-fill-secondary-100',
                stroke: 'r-stroke-secondary-100',
            };
            break;
        case 'secondaryDarker':
        case 'accent2':
            match = {
                bg: 'r-bg-secondary-400',
                text: 'r-text-secondary-400',
                border: 'r-border-secondary-400',
                fill: 'r-fill-secondary-400',
                stroke: 'r-stroke-secondary-400',
            };
            break;
        case 'secondaryDarkest':
        case 'accent1':
            match = {
                bg: 'r-bg-secondary-500',
                text: 'r-text-secondary-500',
                border: 'r-border-secondary-500',
                fill: 'r-fill-secondary-500',
                stroke: 'r-stroke-secondary-500',
            };
            break;
        case 'superLightBlue':
        case 'primaryLightest':
            match = {
                bg: 'r-bg-[#00D7B4]',
                text: 'r-text-[#00D7B4]',
                border: 'r-border-[#00D7B4]',
                fill: 'r-fill-[#00D7B4]',
                stroke: 'r-stroke-[#00D7B4]',
            };
            break;
        case 'lightPeach':
            match = {
                bg: 'r-bg-[#fdb987]',
                text: 'r-text-[#fdb987]',
                border: 'r-border-[#fdb987]',
                fill: 'r-fill-[#fdb987]',
                stroke: 'r-stroke-[#fdb987]',
            };
            break;
        case 'pink':
            match = {
                bg: 'r-bg-[#ff97ae]',
                text: 'r-text-[#ff97ae]',
                border: 'r-border-[#ff97ae]',
                fill: 'r-fill-[#ff97ae]',
                stroke: 'r-stroke-[#ff97ae]',
            };
            break;
        case 'lightPink':
            match = {
                bg: 'r-bg-[#f7ced7]',
                text: 'r-text-[#f7ced7]',
                border: 'r-border-[#f7ced7]',
                fill: 'r-fill-[#f7ced7]',
                stroke: 'r-stroke-[#f7ced7]',
            };
            break;
        case 'greenLoan':
            match = {
                bg: 'r-bg-[#b2d6d3]',
                text: 'r-text-[#b2d6d3]',
                border: 'r-border-[#b2d6d3]',
                fill: 'r-fill-[#b2d6d3]',
                stroke: 'r-stroke-[#b2d6d3]',
            };
            break;
        case 'grayDarkest':
            match = {
                bg: 'r-bg-neutral-900',
                text: 'r-text-neutral-900',
                border: 'r-border-neutral-900',
                fill: 'r-fill-neutral-900',
                stroke: 'r-stroke-neutral-900',
            };
            break;
        case 'grayDarker':
            match = {
                bg: 'r-bg-[#2f353d]',
                text: 'r-text-[#2f353d]',
                border: 'r-border-[#2f353d]',
                fill: 'r-fill-[#2f353d]',
                stroke: 'r-stroke-[#2f353d]',
            };
            break;
        case 'grayDark':
            match = {
                bg: 'r-bg-zinc-600',
                text: 'r-text-zinc-600',
                border: 'r-border-zinc-600',
                fill: 'r-fill-zinc-600',
                stroke: 'r-stroke-zinc-600',
            };
            break;
        case 'grayAlt':
            match = {
                bg: 'r-bg-[#646464]',
                text: 'r-text-[#646464]',
                border: 'r-border-[#646464]',
                fill: 'r-fill-[#646464]',
                stroke: 'r-stroke-[#646464]',
            };
            break;
        case 'gray':
            match = {
                bg: 'r-bg-[#83838f]',
                text: 'r-text-[#83838f]',
                border: 'r-border-[#83838f]',
                fill: 'r-fill-[#83838f]',
                stroke: 'r-stroke-[#83838f]',
            };
            break;
        case 'grayLighter':
            match = {
                bg: 'r-bg-neutral-400',
                text: 'r-text-neutral-400',
                border: 'r-border-neutral-400',
                fill: 'r-fill-neutral-400',
                stroke: 'r-stroke-neutral-400',
            };
            break;
        case 'grayLightest':
            match = {
                bg: 'r-bg-neutral-400',
                text: 'r-text-neutral-400',
                border: 'r-border-neutral-400',
                fill: 'r-fill-neutral-400',
                stroke: 'r-stroke-neutral-400',
            };
            break;
        case 'blueLightest':
            match = {
                bg: 'r-bg-slate-100',
                text: 'r-text-slate-100',
                border: 'r-border-slate-100',
                fill: 'r-fill-slate-100',
                stroke: 'r-stroke-slate-100',
            };
            break;
        case 'blueLight':
            match = {
                bg: 'r-bg-[#e6faff]',
                text: 'r-text-[#e6faff]',
                border: 'r-border-[#e6faff]',
                fill: 'r-fill-[#e6faff]',
                stroke: 'r-stroke-[#e6faff]',
            };
            break;
        case 'lightAlt':
            match = {
                bg: 'r-bg-neutral-200',
                text: 'r-text-neutral-200',
                border: 'r-border-neutral-200',
                fill: 'r-fill-neutral-200',
                stroke: 'r-stroke-neutral-200',
            };
            break;
        case 'transparent':
            match = {
                bg: 'r-bg-transparent',
                text: 'r-text-transparent',
                border: 'r-border-transparent',
                fill: 'r-fill-transparent',
                stroke: 'r-stroke-transparent',
            };
            break;
        case 'accent3':
            match = {
                bg: 'r-bg-[#fdb987]',
                text: 'r-text-[#fdb987]',
                border: 'r-border-[#fdb987]',
                fill: 'r-fill-[#fdb987]',
                stroke: 'r-stroke-[#fdb987]',
            };
            break;
        case 'accent4':
            match = {
                bg: 'r-bg-[#ff97ae]',
                text: 'r-text-[#ff97ae]',
                border: 'r-border-[#ff97ae]',
                fill: 'r-fill-[#ff97ae]',
                stroke: 'r-stroke-[#ff97ae]',
            };
            break;
        case 'accent5':
            match = {
                bg: 'r-bg-[#f7ced7]',
                text: 'r-text-[#f7ced7]',
                border: 'r-border-[#f7ced7]',
                fill: 'r-fill-[#f7ced7]',
                stroke: 'r-stroke-[#f7ced7]',
            };
            break;
        case 'accent6':
            match = {
                bg: 'r-bg-[#f8e5eb]',
                text: 'r-text-[#f8e5eb]',
                border: 'r-border-[#f8e5eb]',
                fill: 'r-fill-[#f8e5eb]',
                stroke: 'r-stroke-[#f8e5eb]',
            };
            break;
        case 'accent7':
            match = {
                bg: 'r-bg-[#ec9bba]',
                text: 'r-text-[#ec9bba]',
                border: 'r-border-[#ec9bba]',
                fill: 'r-fill-[#ec9bba]',
                stroke: 'r-stroke-[#ec9bba]',
            };
            break;
        case 'accent8':
            match = {
                bg: 'r-bg-[#d6ebea]',
                text: 'r-text-[#d6ebea]',
                border: 'r-border-[#d6ebea]',
                fill: 'r-fill-[#d6ebea]',
                stroke: 'r-stroke-[#d6ebea]',
            };
            break;
        case 'accent9':
            match = {
                bg: 'r-bg-[#f2e9e5]',
                text: 'r-text-[#f2e9e5]',
                border: 'r-border-[#f2e9e5]',
                fill: 'r-fill-[#f2e9e5]',
                stroke: 'r-stroke-[#f2e9e5]',
            };
            break;
        case 'accent10':
            match = {
                bg: 'r-bg-[#bfdfde]',
                text: 'r-text-[#bfdfde]',
                border: 'r-border-[#bfdfde]',
                fill: 'r-fill-[#bfdfde]',
                stroke: 'r-stroke-[#bfdfde]',
            };
            break;
        case 'success':
            match = {
                bg: 'r-bg-[#6cc24a]',
                text: 'r-text-[#6cc24a]',
                border: 'r-border-[#6cc24a]',
                fill: 'r-fill-[#6cc24a]',
                stroke: 'r-stroke-[#6cc24a]',
            };
            break;
        case 'error':
            match = {
                bg: 'r-bg-error',
                text: 'r-text-error',
                border: 'r-border-error',
                fill: 'r-fill-error',
                stroke: 'r-stroke-error',
            };
            break;
        case 'bulletListOrange':
            match = {
                bg: 'r-bg-orange-600',
                text: 'r-text-orange-600',
                border: 'r-border-orange-600',
                fill: 'r-fill-orange-600',
                stroke: 'r-stroke-orange-600',
            };
            break;
        case 'blueText':
            match = {
                bg: 'r-bg-blue-900',
                text: 'r-text-blue-900',
                border: 'r-border-blue-900',
                fill: 'r-fill-blue-900',
                stroke: 'r-stroke-blue-900',
            };
            break;
        case 'listCheck':
            match = {
                bg: 'r-bg-[#27C0A8]',
                text: 'r-text-[#27C0A8]',
                border: 'r-border-[#27C0A8]',
                fill: 'r-fill-[#27C0A8]',
                stroke: 'r-stroke-[#27C0A8]',
            };
            break;
        case 'mintGreen':
            match = {
                bg: 'r-bg-[#D6EBE5]',
                text: 'r-text-[#D6EBE5]',
                border: 'r-border-[#D6EBE5]',
                fill: 'r-fill-[#D6EBE5]',
                stroke: 'r-stroke-[#D6EBE5]',
            };
            break;
        case 'lightBrown':
            match = {
                bg: 'r-bg-[rgb(76,61,55)]',
                text: 'r-text-[rgb(76,61,55)]',
                border: 'r-border-[rgb(76,61,55)]',
                fill: 'r-fill-[rgb(76,61,55)]',
                stroke: 'r-stroke-[rgb(76,61,55)]',
            };
            break;
        case 'beige':
            match = {
                bg: 'r-bg-[rgb(242,236,232)]',
                text: 'r-text-[rgb(242,236,232)]',
                border: 'r-border-[rgb(242,236,232)]',
                fill: 'r-fill-[rgb(242,236,232)]',
                stroke: 'r-stroke-[rgb(242,236,232)]',
            };
            break;
        case 'darkBeige':
            match = {
                bg: 'r-bg-[rgb(229,221,213)]',
                text: 'r-text-[rgb(229,221,213)]',
                border: 'r-border-[rgb(229,221,213)]',
                fill: 'r-fill-[rgb(229,221,213)]',
                stroke: 'r-stroke-[rgb(229,221,213)]',
            };
            break;
        case 'warmWhite':
            match = {
                bg: 'r-bg-[#f7f0eb]',
                text: 'r-text-[#f7f0eb]',
                border: 'r-border-[#f7f0eb]',
                fill: 'r-fill-[#f7f0eb]',
                stroke: 'r-stroke-[#f7f0eb]',
            };
            break;
        case '#e9f3f0':
            match = {
                bg: 'r-bg-[#e9f3f0]',
                text: 'r-text-[#e9f3f0]',
                border: 'r-border-[#e9f3f0]',
                fill: 'r-fill-[#e9f3f0]',
                stroke: 'r-stroke-[#e9f3f0]',
            };
            break;
        case '#daefe8':
            match = {
                bg: 'r-bg-[#daefe8]',
                text: 'r-text-[#daefe8]',
                border: 'r-border-[#daefe8]',
                fill: 'r-fill-[#daefe8]',
                stroke: 'r-stroke-[#daefe8]',
            };
            break;
        case '#18968b':
            match = {
                bg: 'r-bg-[#18968b]',
                text: 'r-text-[#18968b]',
                border: 'r-border-[#18968b]',
                fill: 'r-fill-[#18968b]',
                stroke: 'r-stroke-[#18968b]',
            };
            break;
        case '#f5ece8':
        case '#f1eae8':
            match = {
                bg: 'r-bg-[#f1eae8]',
                text: 'r-text-[#f1eae8]',
                border: 'r-border-[#f1eae8]',
                fill: 'r-fill-[#f1eae8]',
                stroke: 'r-stroke-[#f1eae8]',
            };
            break;
        case '#e7dcd6':
            match = {
                bg: 'r-bg-[#e7dcd6]',
                text: 'r-text-[#e7dcd6]',
                border: 'r-border-[#e7dcd6]',
                fill: 'r-fill-[#e7dcd6]',
                stroke: 'r-stroke-[#e7dcd6]',
            };
            break;
        case '#393838':
            match = {
                bg: 'r-bg-[#393838]',
                text: 'r-text-[#393838]',
                border: 'r-border-[#393838]',
                fill: 'r-fill-[#393838]',
                stroke: 'r-stroke-[#393838]',
            };
            break;
        case '#ffec89':
            match = {
                bg: 'r-bg-[#ffec89]',
                text: 'r-text-[#ffec89]',
                border: 'r-border-[#ffec89]',
                fill: 'r-fill-[#ffec89]',
                stroke: 'r-stroke-[#ffec89]',
            };
            break;
    }

    if (!match || !property) {
        return null;
    }

    return match[property] ?? null;
}

export const mapColor = (key?: string) => colors[key as keyof typeof colors] ?? null;

export const hexToRgba = (hexCode: string, opacity = 1) => {
    let hex = hexCode.replace('#', '');

    if (hex.length === 3) {
        hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
    }

    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const addOpacityToRgb = (rgb: string, opacity: number) => {
    const rgbValues = rgb.match(/\d+/g);
    if (rgbValues && rgbValues.length === 3) {
        const [r, g, b] = rgbValues.map(Number);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
    return rgb;
};
